module.exports = __webpack_public_path__ + "fonts/feather.931c9e74.eot";